import { UseMutationOptions, useMutation } from '@tanstack/react-query'

import { API_ENDPOINTS } from '../../../common/apiEndpoints'
import {
  LoginResponse,
  LoginInput,
  loginResponseSchema,
  ErrorResponse,
} from '../../../common/validations'

import { post } from 'api/apiClient'

export const useAPILogin = (
  options?: UseMutationOptions<LoginResponse, ErrorResponse, LoginInput>
) =>
  useMutation({
    mutationFn: (values) =>
      post(API_ENDPOINTS.LOGIN, values, loginResponseSchema),
    throwOnError: false,
    ...options,
  })
